import ViewMojeKonto from "../../components/views/konto/ViewMojeKonto.jsx";
import ViewMojeUprawnienia from "../../components/views/konto/ViewMojeUprawnienia.jsx";
import ViewZmianaDanych from "../../components/views/konto/ViewZmianaDanych.jsx";

export const otherRoutes = [

    {
        path: '/uzytkownik/moje-dane',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeKonto/>,
        mode: 'pass'
    },
    {
        path: '/moje-konto',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeKonto/>,
        mode: 'pass'
    },
    {
        path: '/uzytkownik/moje-uprawnienia',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeUprawnienia/>,
        mode: 'pass'
    },
    {
        path: '/uzytkownik/zmiana-danych',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewZmianaDanych/>,
        mode: 'pass'
    },
    {
        path: '/moje-uprawnienia',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeUprawnienia/>,
        mode: 'pass'
    },

]
